// @ts-nocheck
/**
 * chat-suggest-lib.js — Canonical suggestion terms for chat autosuggest.
 *
 * This module is data-only for now. It centralizes color terms, flower terms,
 * known aliases, and inventory-backed entries so autosuggest can be wired
 * incrementally without bloating chat.js.
 */
(function () {
  'use strict';

  window.AIFlorist = window.AIFlorist || {};

  var COLORS = [
    'white', 'ivory', 'cream', 'champagne', 'beige', 'nude', 'blush',
    'soft pink', 'pink', 'hot pink', 'fuchsia', 'peach', 'apricot',
    'coral', 'salmon', 'red', 'scarlet', 'burgundy', 'wine', 'orange',
    'terracotta', 'yellow', 'butter yellow', 'gold', 'lilac', 'lavender',
    'purple', 'violet', 'blue', 'powder blue', 'dusty blue', 'teal',
    'green', 'sage', 'olive', 'emerald', 'brown', 'mocha', 'black',
    'grey', 'silver', 'pastel', 'neutral', 'earthy', 'jewel tone',
  ];

  var FLOWER_TYPES = [
    'rose', 'spray rose', 'garden rose', 'tulip', 'peony', 'ranunculus',
    'lily', 'calla lily', 'lisianthus', 'carnation', 'hydrangea', 'gerbera',
    'daisy', 'chrysanthemum', 'sunflower', 'orchid', 'anthurium', 'alstroemeria',
    'baby\'s breath', 'freesia', 'iris', 'anemone', 'dahlia', 'delphinium',
    'snapdragon', 'stock', 'protea', 'wax flower', 'statice', 'aster',
    'scabiosa', 'sweet pea', 'cotton flower',
  ];

  // Inventory-backed baseline from:
  // - worker/migrations/0005_flower_inventory_seed.sql
  // - worker/src/services/flower-availability.test.ts fixture
  var INVENTORY_BASELINE = [
    {
      category: 'Roses',
      type: 'fresh',
      varieties: ['China Quicksand Rose', 'Juliet Rose', 'Hitomi Rose'],
    },
    {
      category: 'Tulips',
      type: 'fresh',
      varieties: ['White Tulip', 'Pink Tulip', 'Red Tulip'],
    },
    {
      category: 'Spray Roses',
      type: 'fresh',
      varieties: [
        'Orange Spray Rose',
        'White Spray Rose',
        'Sweet Sara Spray Rose',
        'Yellow Spray Rose',
        'Hot Pink Spray Rose',
        'Red Spray Rose',
      ],
    },
    {
      category: 'Foliage & Greens',
      type: 'fresh',
      varieties: ['Italian Ruscus', 'Eucalyptus Parvifolia', 'Eucalyptus Cinerea'],
    },
    {
      category: 'Preserved Roses',
      type: 'preserved',
      varieties: ['White Preserved Rose', 'Hot Pink Preserved Rose'],
    },
    {
      category: 'Preserved Hydrangeas',
      type: 'preserved',
      varieties: [
        'White Preserved Hydrangea',
        'Light Pink Preserved Hydrangea',
        'Rosewood Preserved Hydrangea',
        'Khaki Preserved Hydrangea',
        'Dusty Blue Preserved Hydrangea',
        'Lilac Preserved Hydrangea',
        'Forest Green Preserved Hydrangea',
        'Peach Preserved Hydrangea',
        'Light Green Preserved Hydrangea',
        'Yellow Preserved Hydrangea',
        'Maroon Preserved Hydrangea',
      ],
    },
    {
      category: 'Vases',
      type: 'container',
      varieties: ['Mason Jar', '1020 Vase'],
    },
    {
      category: 'Boxes',
      type: 'container',
      varieties: [
        'Black Felt Box',
        'White Felt Box',
        'Wonderland Box - Black (Large)',
        'Wonderland Box - Black (Medium)',
        'Wonderland Box - Black (Small)',
        'Wonderland Box - Lilac (Large)',
        'Wonderland Box - Lilac (Small)',
        'Wonderland Box - Pink (Large)',
        'Wonderland Box - Pink (Medium)',
        'Wonderland Box - Pink (Small)',
      ],
    },
    {
      category: 'Stands',
      type: 'container',
      varieties: ['Tripod Stand', 'Black Box Stand'],
    },
    {
      category: 'Pots',
      type: 'container',
      varieties: ['Centrepiece Pot - Beige-White/White Pleated'],
    },
  ];

  var PHRASE_STARTERS = [
    'white tulips',
    'white roses',
    'white and green bouquet',
    'blush pink bouquet',
    'pastel mixed bouquet',
    'romantic pink bouquet',
    'minimal white bouquet',
    'rose and tulip bouquet',
    'hydrangea and rose bouquet',
    'sunflower and daisy bouquet',
    'baby\'s breath bouquet',
    'eucalyptus and white roses',
  ];

  var ALIASES = {
    tulps: 'tulips',
    tulipes: 'tulips',
    peonie: 'peony',
    peonies: 'peony',
    lillies: 'lilies',
    babys: 'baby\'s',
    'babys breath': 'baby\'s breath',
    'baby breath': 'baby\'s breath',
    chrysanth: 'chrysanthemum',
    eustoma: 'lisianthus',
    matthiola: 'stock',
    hydrangeas: 'hydrangea',
    ranunculuses: 'ranunculus',
  };

  function collectInventoryFlowerTerms() {
    var terms = [];
    for (var i = 0; i < INVENTORY_BASELINE.length; i++) {
      var row = INVENTORY_BASELINE[i];
      for (var j = 0; j < row.varieties.length; j++) {
        terms.push(row.varieties[j]);
      }
    }
    return dedupe(terms);
  }

  function buildColorFlowerPhrases(limit) {
    var output = [];
    var max = typeof limit === 'number' ? limit : 80;
    var basics = ['Roses', 'Tulips', 'Peonies', 'Lilies', 'Hydrangeas', 'Ranunculus'];
    for (var i = 0; i < COLORS.length; i++) {
      for (var j = 0; j < basics.length; j++) {
        output.push(toTitleCase(COLORS[i]) + ' ' + basics[j]);
        if (output.length >= max) return output;
      }
    }
    return output;
  }

  function normalizeTerm(raw) {
    var term = String(raw || '').trim().toLowerCase();
    return ALIASES[term] || term;
  }

  function dedupe(values) {
    var seen = {};
    var out = [];
    for (var i = 0; i < values.length; i++) {
      var key = String(values[i] || '').trim();
      if (!key || seen[key]) continue;
      seen[key] = true;
      out.push(key);
    }
    return out;
  }

  function toTitleCase(text) {
    return String(text || '').replace(/\b([a-z])/g, function (m) {
      return m.toUpperCase();
    });
  }

  function getLibrary() {
    return {
      colors: COLORS.map(toTitleCase),
      flowerTypes: FLOWER_TYPES.map(toTitleCase),
      inventoryBaseline: INVENTORY_BASELINE.slice(),
      inventoryFlowerTerms: collectInventoryFlowerTerms(),
      phraseStarters: PHRASE_STARTERS.map(toTitleCase),
      generatedColorFlowerPhrases: buildColorFlowerPhrases(90),
      aliases: Object.assign({}, ALIASES),
    };
  }

  window.AIFlorist.suggestLib = {
    getLibrary: getLibrary,
    normalizeTerm: normalizeTerm,
    buildColorFlowerPhrases: buildColorFlowerPhrases,
  };
})();
